import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export interface CheckinSectionProps {
  checkin?: string
  checkout?: string
  timezone?: string
}

export const CheckinSection = ({
  checkin,
  checkout,
  timezone,
}: CheckinSectionProps) => {
  const { t } = useTranslation()

  return (
    <Paper
      padding={[12, 14]}
      radius="16"
    >
      <div className={clsx('medium-14', s.checkinCheckout)}>
        <p>
          {t('kyrgyzstan_block.detail.checkin_checkout', {
            checkin,
            checkout,
          })}
        </p>
        {timezone && <p>{t('kyrgyzstan_block.timezone', { timezone })}</p>}
      </div>
    </Paper>
  )
}
